import { render, staticRenderFns } from "./TheThreadItem.vue?vue&type=template&id=1e4c9f69&scoped=true"
import script from "./TheThreadItem.vue?vue&type=script&lang=js"
export * from "./TheThreadItem.vue?vue&type=script&lang=js"
import style0 from "./TheThreadItem.vue?vue&type=style&index=0&id=1e4c9f69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4c9f69",
  null
  
)

export default component.exports